"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendFavotitePagenationTypes = void 0;
exports.FriendFavotitePagenationTypes = ["group_0", "group_1", "group_2"];
